import { useContext } from "react";
import CheckoutContext from "../../checkout-context";

export function Step(props) {
  const { isActive, children } = props;

  const { customerDataValid } = useContext(CheckoutContext);

  return (
    <div
      className={`multi-step__step ${customerDataValid ? "" : "form-invalid"} ${
        isActive ? "visible" : ""
      }`}
    >
      {children}
    </div>
  );
}
